module.exports = __webpack_public_path__ + "img/add_circle_outline.24a5986c.svg";